/**
 * Role mapping for organisations.
 * Maps org IDs to their role categories — describing
 * what role each org plays in the hasbara ecosystem.
 *
 * Categories:
 *  - Political Lobbying
 *  - Media & Communications
 *  - Campus & Youth
 *  - Policy & Research
 *  - Surveillance & Monitoring
 *  - Fundraising & Philanthropy
 *  - State Institution
 *  - Settlement & Colonisation
 *  - Cultural Programming
 *  - Christian Zionism
 *  - Trade & Business
 *  - Legal
 *  - Security
 */

const roleMap = {
  'amcha-initiative': ['Campus & Youth', 'Surveillance & Monitoring'],
  'aen': ['Campus & Youth'],
  'act-il': ['Media & Communications', 'Surveillance & Monitoring'],
  'amadeu-antonio': ['Policy & Research'],
  'aipac': ['Political Lobbying'],
  'ajc': ['Political Lobbying'],
  'adl': ['Surveillance & Monitoring', 'Political Lobbying'],
  'aujs': ['Campus & Youth'],
  'azyc': ['Campus & Youth'],
  'aicc': ['Trade & Business'],
  'aijac': ['Policy & Research', 'Media & Communications'],
  'five-a': ['Campus & Youth'],
  'aja': ['Media & Communications'],
  'birthright': ['Cultural Programming'],
  'board-of-deputies': ['Political Lobbying'],
  'bicom': ['Media & Communications', 'Political Lobbying'],
  'caa': ['Legal', 'Surveillance & Monitoring'],
  'cjpac': ['Political Lobbying'],
  'canary-mission': ['Campus & Youth', 'Surveillance & Monitoring'],
  'zentralrat': ['Political Lobbying'],
  'cija': ['Political Lobbying'],
  'cufi': ['Christian Zionism'],
  'c4i-australia': ['Christian Zionism'],
  'camera': ['Media & Communications'],
  'cst': ['Security'],
  'conference-of-presidents': ['Political Lobbying'],
  'cfi': ['Political Lobbying'],
  'dmfi': ['Political Lobbying'],
  'ecaj': ['Political Lobbying'],
  'antisemitism-commissioner-de': ['State Institution'],
  'fdd': ['Policy & Research'],
  'fswc': ['Cultural Programming', 'Campus & Youth'],
  'friends-of-the-idf': ['Fundraising & Philanthropy', 'Security'],
  'fidf-canada': ['Fundraising & Philanthropy'],
  'dig': ['Cultural Programming', 'Political Lobbying'],
  'hillel-canada': ['Campus & Youth'],
  'hillel': ['Campus & Youth'],
  'honest-reporting': ['Media & Communications'],
  'honest-reporting-australia': ['Media & Communications'],
  'honest-reporting-canada': ['Media & Communications'],
  'ihra': ['State Institution', 'Legal'],
  'icc': ['Campus & Youth'],
  'jewish-agency': ['Settlement & Colonisation', 'State Institution'],
  'jccv': ['Political Lobbying'],
  'jcf-sf': ['Fundraising & Philanthropy'],
  'jcf-la': ['Fundraising & Philanthropy'],
  'jfna': ['Fundraising & Philanthropy'],
  'jinsa': ['Policy & Research'],
  'jlc': ['Political Lobbying'],
  'jnf': ['Settlement & Colonisation', 'Fundraising & Philanthropy'],
  'jnf-australia': ['Settlement & Colonisation', 'Fundraising & Philanthropy'],
  'jnf-canada': ['Settlement & Colonisation', 'Fundraising & Philanthropy'],
  'jnf-germany': ['Settlement & Colonisation', 'Fundraising & Philanthropy'],
  'jewish-national-fund-uk': ['Settlement & Colonisation', 'Fundraising & Philanthropy'],
  'jewish-national-fund-usa': ['Settlement & Colonisation', 'Fundraising & Philanthropy'],
  'lfi': ['Political Lobbying'],
  'maccabi-australia': ['Cultural Programming'],
  'memri': ['Media & Communications', 'Policy & Research'],
  'ministry-strategic-affairs': ['State Institution', 'Surveillance & Monitoring'],
  'nsw-jbd': ['Political Lobbying'],
  'nain': ['Christian Zionism'],
  'republican-jewish-coalition': ['Political Lobbying', 'Fundraising & Philanthropy'],
  'reut-institute': ['Policy & Research'],
  'simon-wiesenthal-center': ['Cultural Programming', 'Political Lobbying'],
  'standwithus': ['Campus & Youth'],
  'standwithus-australia': ['Campus & Youth'],
  'standwithus-canada': ['Campus & Youth'],
  'students-supporting-israel': ['Campus & Youth'],
  'ssi-australia': ['Campus & Youth'],
  'tip': ['Media & Communications'],
  'transatlantic-institute': ['Policy & Research', 'Political Lobbying'],
  'uklfi': ['Legal'],
  'ujs': ['Campus & Youth'],
  'uia-australia': ['Fundraising & Philanthropy'],
  'ujia': ['Fundraising & Philanthropy'],
  'winep': ['Policy & Research'],
  'we-believe-in-israel': ['Media & Communications', 'Political Lobbying'],
  'wjc-germany': ['Political Lobbying'],
  'wujs': ['Campus & Youth'],
  'wzo': ['Settlement & Colonisation'],
  'zfa': ['Settlement & Colonisation', 'Political Lobbying'],
  'zionist-federation-gb': ['Settlement & Colonisation', 'Political Lobbying'],
  'zoa': ['Political Lobbying', 'Settlement & Colonisation'],
};

/**
 * Get roles for an org. Prefers org.roles from API data (passed as second arg),
 * falls back to static roleMap if not available.
 */
export function getRolesForOrg(orgId, apiRoles) {
  if (Array.isArray(apiRoles) && apiRoles.length > 0) return apiRoles;
  return roleMap[orgId] || [];
}

export default roleMap;
